import { useState } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/daf8t2rep053ijub1le0';

const topics = ['想追更的系列提议', '剧情补充 / 线索投稿', '网页功能建议', '合作 / 其他'];

export default function ContactForm() {
  const [sent, setSent] = useState('');
  const [formError, setFormError] = useState('');
  const [len, setLen] = useState(0);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);
    setSent('');
    setFormError('');
    const form = e.currentTarget;
    const fd = new FormData(form);
    const bot = (fd.get('website_alt') || '').toString().trim();
    if (bot) {
      setSubmitting(false);
      setSent('收到啦！我们已经记下你的反馈，感谢支持。');
      return;
    }
    fd.delete('website_alt');
    const body = new URLSearchParams(fd as unknown as Record<string, string>).toString();
    try {
      const res = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body,
      });
      const responseText = await res.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || responseText;
      const isOk = res.ok && parsed?.code === 'OK';
      if (isOk) {
        setSent('提交成功！谢谢你的分享，我们会认真阅读每一封来信。');
        form.reset();
        setLen(0);
      } else {
        setFormError(
          typeof serverMsg === 'string' && serverMsg
            ? serverMsg
            : '提交遇到问题，请稍后再试。'
        );
      }
    } catch {
      setFormError('网络开小差了，请稍后再试一次。');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form
      id="contact-form"
      data-readdy-form="吃瓜每日意见与线索投稿"
      onSubmit={onSubmit}
      className="flex flex-col gap-4"
    >
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <label htmlFor="cname" className="mb-1.5 block text-sm font-medium text-foreground-800">
            怎么称呼你
          </label>
          <input
            id="cname"
            name="name"
            type="text"
            required
            placeholder="昵称或称呼"
            className="h-11 w-full rounded-xl border border-background-200 bg-background-100/50 px-4 text-sm text-foreground-950 outline-none placeholder:text-foreground-400 focus:border-primary-300 focus:bg-background-50"
          />
        </div>
        <div>
          <label htmlFor="cemail" className="mb-1.5 block text-sm font-medium text-foreground-800">
            常用邮箱
          </label>
          <input
            id="cemail"
            name="email"
            type="email"
            required
            placeholder="you@example.com"
            className="h-11 w-full rounded-xl border border-background-200 bg-background-100/50 px-4 text-sm text-foreground-950 outline-none placeholder:text-foreground-400 focus:border-primary-300 focus:bg-background-50"
          />
        </div>
      </div>

      <div>
        <label htmlFor="ctopic" className="mb-1.5 block text-sm font-medium text-foreground-800">
          想聊点什么
        </label>
        <select
          id="ctopic"
          name="topic"
          defaultValue={topics[0]}
          className="h-11 w-full rounded-xl border border-background-200 bg-background-100/50 px-3 text-sm text-foreground-950 outline-none focus:border-primary-300"
        >
          {topics.map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>
      </div>

      <div>
        <label htmlFor="cmsg" className="mb-1.5 block text-sm font-medium text-foreground-800">
          想说的话 / 投稿内容
        </label>
        <textarea
          id="cmsg"
          name="message"
          required
          maxLength={500}
          value={undefined}
          onChange={(e) => setLen(e.target.value.length)}
          placeholder="把你追更的故事、想补充的剧情或建议告诉我们吧…"
          rows={5}
          className="w-full resize-none rounded-xl border border-background-200 bg-background-100/50 px-4 py-3 text-sm leading-6 text-foreground-950 outline-none placeholder:text-foreground-400 focus:border-primary-300 focus:bg-background-50"
        ></textarea>
        <p className="mt-1 text-right text-xs text-foreground-400">{len}/500</p>
      </div>

      {/* 防垃圾隐藏字段 */}
      <div className="hp-guard" aria-hidden="true">
        <label htmlFor="website_alt">网站</label>
        <input
          type="text"
          id="website_alt"
          name="website_alt"
          tabIndex={-1}
          autoComplete="off"
          readOnly
        />
      </div>

      {sent && (
        <p className="rounded-xl bg-accent-100 px-4 py-3 text-sm font-medium text-accent-800">
          <i className="ri-checkbox-circle-line mr-1.5"></i>{sent}
        </p>
      )}
      {formError && (
        <p className="rounded-xl bg-primary-100 px-4 py-3 text-sm font-medium text-primary-700">
          <i className="ri-error-warning-line mr-1.5"></i>{formError}
        </p>
      )}

      <button
        type="submit"
        disabled={submitting}
        className="flex h-12 items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-8 text-base font-bold text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
      >
        {submitting ? (
          <span className="flex items-center gap-2"><i className="ri-loader-4-line animate-spin"></i>发送中</span>
        ) : (
          <span className="flex items-center gap-2"><i className="ri-send-plane-line"></i>发送留言</span>
        )}
      </button>
    </form>
  );
}